var _path, _mask, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 15.7486V11.4629C26.0006 8.81072 24.9471 6.26718 23.0716 4.39183C21.1963 2.51646 18.6527 1.46289 16.0006 1.46289C13.3484 1.46289 10.8048 2.51646 8.9295 4.39183C7.05413 6.26718 6.00056 8.81072 6.00056 11.4629V15.7486M27.4291 15.7486H4.57199C2.99404 15.7486 1.71484 17.0278 1.71484 18.6057V35.7486C1.71484 37.3266 2.99404 38.6057 4.57199 38.6057H27.4291C29.0071 38.6057 30.2863 37.3266 30.2863 35.7486V18.6057C30.2863 17.0278 29.0071 15.7486 27.4291 15.7486Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_7374_7042",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9036 29.6991C14.5222 29.6991 13.4023 28.58 13.4023 27.1992C13.4023 25.8183 14.5222 24.6992 15.9036 24.6992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9001 29.6992C17.2825 29.6992 18.4023 28.5801 18.4023 27.1993C18.4023 25.8184 17.2825 24.6993 15.9001 24.6993"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9036 31.1991C16.732 31.1991 17.4036 30.5275 17.4036 29.6991C17.4036 28.8707 16.732 28.1991 15.9036 28.1991V31.1991ZM15.9036 26.1992C16.732 26.1992 17.4036 25.5276 17.4036 24.6992C17.4036 23.8708 16.732 23.1992 15.9036 23.1992V26.1992ZM15.9001 28.1992C15.0717 28.1992 14.4001 28.8708 14.4001 29.6992C14.4001 30.5276 15.0717 31.1992 15.9001 31.1992V28.1992ZM15.9001 23.1993C15.0717 23.1993 14.4001 23.8709 14.4001 24.6993C14.4001 25.5278 15.0717 26.1993 15.9001 26.1993V23.1993ZM15.9036 28.1991C15.3498 28.1991 14.9023 27.7508 14.9023 27.1992H11.9023C11.9023 29.4093 13.6945 31.1991 15.9036 31.1991V28.1991ZM14.9023 27.1992C14.9023 26.6475 15.3498 26.1992 15.9036 26.1992V23.1992C13.6945 23.1992 11.9023 24.9891 11.9023 27.1992H14.9023ZM15.9001 31.1992C18.1098 31.1992 19.9023 29.4098 19.9023 27.1993H16.9023C16.9023 27.7505 16.4553 28.1992 15.9001 28.1992V31.1992ZM19.9023 27.1993C19.9023 24.9888 18.1098 23.1993 15.9001 23.1993V26.1993C16.4553 26.1993 16.9023 26.648 16.9023 27.1993H19.9023Z",
    fill: "black",
    mask: "url(#path-2-inside-1_7374_7042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.71908100416429d6b8bc62c31cf41cc3.svg";
export { ForwardRef as ReactComponent };